
import {BoundTls} from './BoundTls';
import {MyTile} from '../map/MyTiles';
import * as L from 'leaflet'

const MapTls = {

  typeBounds(document, mymap) {
    if(document.getElementById('top-bound'))
    document.getElementById('top-bound').innerHTML = mymap.getBounds().getNorthWest().utm().toString().slice(0, 24);
    if(document.getElementById('bottom-bound'))
    document.getElementById('bottom-bound').innerHTML = mymap.getBounds().getSouthEast().utm().toString().slice(0, 24);
  },

  fitTo(mymap) {
    // mymap.setView(Tls.u1(bTls.getMinMaxBound().getMiddle()),18.5);
    mymap.fitBounds(BoundTls.getMinMaxBound().getBound(), { maxZoom: 22, padding: [0, 0],zoomSnap: 0.1, });
    var f = BoundTls.getMinMaxBound().getBound();
    // var f = BoundTls.getMinMaxBound().getBound();

    // mymap.setView(mymap.getCenter(),19); // TODO zoomTo
    return f;
    // var marker1 = L.marker(f[0]).addTo(mymap);
    // var marker2 = L.marker(f[1]).addTo(mymap);


  },

  initMap(divId, option={printable:false,editable:false}) {
    var isPrintable = option.printable;
    var isEditable = option.editable;

    L.Map.include({
      'clearLayers': function () {
        this.eachLayer(function (layer) {
          this.removeLayer(layer);

        }, this);
        MyTile.getTile(L).addTo(mymap);
      }
    });


    // var coord = Tls.uNotSave(300270.33050000, 3796436.76440000);
    var mymap = L.map(divId, {
      editable: isEditable,
      zoomControl: !isPrintable,
      attributionControl: !isPrintable,
      zoomSnap: 0,
      zoomDelta: 0.05,
      rotate: true, 
      // zoomControl: false,
      //  renderer : labelTextCollision
    })

    // mymap.touchZoom.disable();
mymap.doubleClickZoom.disable();
// mymap.scrollWheelZoom.disable();
// mymap.boxZoom.disable();
// mymap.keyboard.disable();
      // .setView(coord, 21);
      // .setView([0, 0], 0);



    MyTile.getTile(L).addTo(mymap);
    L.control.scale({ metric: true, imperial: false }).addTo(mymap);

    // var popup = L.popup();
    // function onMapClick(e) {
    //     popup
    //         .setLatLng(e.latlng)
    //         .setContent("You clicked the map at " + e.latlng.toString())
    //         .openOn(mymap);
    // }
    // mymap.on('click', onMapClick);

    return mymap;
  },
  getBoundInAltLat(mymap){
    var sw = mymap.getBounds()._southWest.utm();
    var ne = mymap.getBounds()._northEast.utm();

    return [{ x: sw.x, y: sw.y }, { x: ne.x, y: ne.y }];
  }
  
};

export {MapTls}